const APP = {
  NAME: 'admin',
  LANGUAGE: 'en'
}

export default APP
